import React from "react";
import { Link } from "react-router-dom";
import "../../assets/generalTrade.css";

const GeneralTradeHome: React.FC = () => {
  return (
    <main className="gt-page">
      <section className="gt-hero">
        <div className="gt-container gt-hero-grid">
          <div className="gt-hero-copy">
            <span className="gt-eyebrow">Lyra Zone General Trading</span>
            <h1>Bringing Quality Essentials Closer to Every Home</h1>
            <p>
              Trusted products, reliable supply and stronger connections with
              households, retailers and communities.
            </p>
            <div className="gt-hero-actions">
              <Link to="/general-trade/about" className="gt-btn gt-btn-primary">
                Discover General Trade
              </Link>
              <Link to="/general-trade/contact" className="gt-btn gt-btn-light">
                Contact Us
              </Link>
            </div>
          </div>

          <div className="gt-hero-visual">
            <img
              src="/images/general-trade/house-of-taste/slide-01.webp"
              alt="House of Taste product profile"
            />
          </div>
        </div>
      </section>

      <section className="gt-value-section">
        <div className="gt-container">
          <div className="gt-section-heading">
            <span>Our Approach</span>
            <h2>Quality products. Reliable supply. Happier homes.</h2>
          </div>

          <div className="gt-value-grid">
            <article><h3>Trusted Quality</h3><p>Everyday essentials selected with quality and consistency in mind.</p></article>
            <article><h3>Retail Partnership</h3><p>Long-term relationships with supermarkets, grocery stores, distributors and retailers.</p></article>
            <article><h3>Customer Reach</h3><p>Focused market engagement that connects products with households and communities.</p></article>
          </div>
        </div>
      </section>
    </main>
  );
};

export default GeneralTradeHome;
